import { Component, type ReactNode } from 'react'
import EmptyState from './EmptyState'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Catches a render error anywhere below it and shows a short message with a
 * Reload button instead of leaving the screen blank. React has no hook
 * equivalent for this — getDerivedStateFromError/componentDidCatch only exist
 * on class components — so this is the one class component in the app.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.error(error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <EmptyState
          title="Något gick fel"
          body="Vyn stötte på ett fel. Att ladda om brukar lösa det."
          actionLabel="Ladda om"
          onAction={() => window.location.reload()}
        />
      )
    }
    return this.props.children
  }
}
